module.exports = __webpack_public_path__ + "img/pt.b5021e58.svg";